import React from "react";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  button: {
    textTransform: "none",
    backgroundColor: theme.palette.text.primary,
    color: "#fff",
    fontSize: "0.9375rem",
    lineHeight: "1.25rem",
    fontWeight: 500,
    letterSpacing: 0,
    padding: theme.spacing(1, 3),
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.8)"
    },
    "&[disabled]": {
      backgroundColor: theme.palette.text.primary,
      color: "#fff",
      opacity: "38%"
    }
  }
}));

export default function BlackButton({
  disabled,
  handleClick = () => {},
  content,
  type = "button",
  className,
  ...other
}) {
  const classes = useStyles();
  return (
    <Button
      className={`${classes.button} ${className ? className : ""}`}
      variant="contained"
      type={type}
      disableElevation
      onClick={handleClick}
      disabled={disabled}
      {...other}
    >
      {content}
    </Button>
  );
}
